import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/esnext.json.parse.js";
import { __decorate } from "tslib";
import WSelectUsers from "@/components/form/w-select-users.vue";
import axios from "axios";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import WAlert from "@/components/wrappers/w-alert.vue";
import WSelectAdvanced from "@/components/form/w-select-advanced.vue";
import { Component, Prop, Vue } from "vue-facing-decorator";
import WTag from "@/components/wrappers/w-tag.vue";
import AnonymousWorkflowSubmit from "@/views/speach/AnonymousWorkflowSubmit.vue";
let ManagePeriodicReviewers = class ManagePeriodicReviewers extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "speachToUpdate", void 0);
    _defineProperty(this, "classClickFilter", void 0);
    _defineProperty(this, "fieldsToUpdate", {
      users: []
    });
    _defineProperty(this, "BASE_API_SPEACHES", '/api/v2/admin/speach');
    _defineProperty(this, "BASE_API_USERS", '/api/v2/admin/users');
  }
  async mounted() {
    // Assign the array to fieldsToUpdate.users
    if (this.speachToUpdate.speachMetadata.periodicReviewUsers !== undefined) {
      this.fieldsToUpdate.users = this.speachToUpdate.speachMetadata.periodicReviewUsers.map(user => this.userToUserInfos(user));
    }
  }
  get usersListEmpty() {
    const users = this.fieldsToUpdate.users;
    // Case 1: proper array
    if (Array.isArray(users)) {
      return users.length === 0;
    }
    // Case 2: stringified JSON
    if (typeof users === 'string') {
      try {
        const parsed = JSON.parse(users);
        return !Array.isArray(parsed) || parsed.length === 0;
      } catch {
        // If it's some unexpected string, treat as empty
        return true;
      }
    }
    // Any other type → treat as empty
    return true;
  }
  userToUserInfos(user) {
    return {
      id: user.id,
      email: user.email,
      label: user.firstName + " " + user.lastName,
      imgUrl: user.img
    };
  }
  async onChangeUsers(value) {
    this.fieldsToUpdate.users = value;
  }
  deleteOneUser(userToDelete) {
    let currentAffectedUsers = this.fieldsToUpdate.users || [];
    currentAffectedUsers = currentAffectedUsers.filter(user => user !== userToDelete);
    this.fieldsToUpdate.users = currentAffectedUsers;
    this.onChangeUsers(this.fieldsToUpdate.users);
  }
  setListUsers(users) {
    this.fieldsToUpdate.users = users;
  }
  submitReviewers() {
    if (!this.fieldsToUpdate) {
      return;
    }
    axios.put(this.BASE_API_SPEACHES + '/create-periodic-review-workflow', {
      speachId: this.speachToUpdate.speachID,
      approvers: this.fieldsToUpdate.users
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(() => {
      WElMessage.showSuccessMessage(this.$t("admin.dashboard.speaches.toasts.speachesBatchUpdated"));
      this.$emit('reviewersSuccess');
    }, error => {
      WElMessage.showLongErrorMessage(this.$t("admin.dashboard.speaches.toasts.speachesBatchUpdateFailed", {
        speachesFailed: this.speachToUpdate.title
      }));
    });
  }
  cancelReviewers() {
    this.$emit('reviewersCancel');
  }
};
__decorate([Prop({
  required: true
})], ManagePeriodicReviewers.prototype, "speachToUpdate", void 0);
__decorate([Prop({
  default: ''
})], ManagePeriodicReviewers.prototype, "classClickFilter", void 0);
ManagePeriodicReviewers = __decorate([Component({
  components: {
    AnonymousWorkflowSubmit,
    WTag,
    WSelectAdvanced,
    WAlert,
    StandardButton,
    WSelectUsers
  },
  emits: ['batchUpdateSuccess', 'batchUpdateCancel']
})], ManagePeriodicReviewers);
export default ManagePeriodicReviewers;